import { faAsterisk, faBan, faCheckDouble, faEraser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Checkbox from '@mui/material/Checkbox';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { deDE } from '@mui/material/locale';
import MenuItem from '@mui/material/MenuItem';
import { px2em } from "ksk/styledComponents/functions";
import React from 'react';

function insertIf(condition, ...elements) { // (A)
  return condition ? elements : [];
}

function OptionsBuilder({ dominio, multiple, classes, selected, emptyOption = true }) {

  const isAllSelected = dominio?.length > 0 && selected?.length === dominio?.filter(d => !d.readOnly).length;

  return dominio ? [
    ...insertIf(emptyOption && !multiple, <MenuItem value="" key={-1} ><span className="disabled-text italic"><FontAwesomeIcon icon={faEraser} style={{marginRight: '.5em'}} />Deixar em branco</span></MenuItem>), /* -- Selecione ↴ */
    ...insertIf(multiple && dominio?.length > 1, (
      <MenuItem key="__ALL__"
        value="__ALL__"
        classes={{
          root: isAllSelected ? classes.selectedAll : ""
        }}
      >
        <ListItemIcon>
          <Checkbox
            classes={{ indeterminate: classes.indeterminateColor }}
            checked={isAllSelected}
            color="primary"
            indeterminate={
              selected?.length > 0 && selected?.length < dominio?.length
            }
          />
        </ListItemIcon>
        <ListItemText
          classes={{ primary: classes.selectAllText }}
          primary={(
            <>
              {
                isAllSelected ? <FontAwesomeIcon icon={faEraser} /> : <FontAwesomeIcon icon={faCheckDouble} />
              }
              
              {/* <FontAwesomeIcon icon={isAllSelected ? faEraser : faCheckDouble}/> */}
              <span className="bold italic"> {isAllSelected ? 'Desmarcar tudo' : 'Marcar tudo'}</span>
              <span className="italic" style={{fontSize: '.85em'}}> (Ctrl + Shift + <span style={{fontSize: '.85em'}}><FontAwesomeIcon icon={faAsterisk} /></span>)</span>
            </>
          )}
        />
      </MenuItem>
      )
    ),

    ...dominio.sort((a, b) => a.ordinal - b.ordinal)
              .map((d, i) => (
                <MenuItem value={d.codigo} key={d.codigo ?? `__index(${i})__`}  disabled={d?.readOnly}>
                  { 
                    multiple 
                    ? <>
                        <ListItemIcon>
                          { d?.readOnly
                            ? <FontAwesomeIcon icon={faBan} style={{marginLeft: px2em(13)}} />
                            : <Checkbox color="primary" checked={selected?.indexOf(d.codigo) > -1} style={{paddingTop:0,paddingBottom:0}} />
                          }
                        </ListItemIcon>
                        <ListItemText primary={d.nome} />
                      </>
                    :
                    d.nome
                  }
                  
                </MenuItem>)
              )] : [];
}

export default OptionsBuilder;
